import { api } from 'api/api';
import { InvoiceDetailsDto, InvoiceDetailsUpsertDto } from 'api/dtos/invoiceDetailsDtos';

export const invoiceDetailsApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getInvoiceDetails: builder.query<InvoiceDetailsDto, void>({
            query: () => ({
                url: '/invoice-details/me',
                method: 'GET',
            }),
            providesTags: ['Account'],
        }),
        createInvoiceDetails: builder.mutation<InvoiceDetailsDto, InvoiceDetailsUpsertDto>({
            query: (body) => ({
                url: '/invoice-details',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['Account'],
            extraOptions: {
                successMessage: 'Dane do faktury zostały zapisane.',
                errorMessage: 'Nie udało się zapisać danych do faktury.',
            },
        }),
        updateInvoiceDetails: builder.mutation<InvoiceDetailsDto, InvoiceDetailsUpsertDto>({
            query: (body) => ({
                url: '/invoice-details',
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['Account'],
            extraOptions: {
                successMessage: 'Dane do faktury zostały zaktualizowane.',
                errorMessage: 'Nie udało się zaktualizować danych do faktury.',
            },
        }),
        deleteInvoiceDetails: builder.mutation<void, void>({
            query: () => ({
                url: '/invoice-details',
                method: 'DELETE',
            }),
            invalidatesTags: ['Account'],
            extraOptions: {
                successMessage: 'Dane do faktury zostały usunięte.',
                errorMessage: 'Nie udało się usunąć danych do faktury.',
            },
        }),
    }),
    overrideExisting: false,
});

export const {
    useGetInvoiceDetailsQuery,
    useCreateInvoiceDetailsMutation,
    useUpdateInvoiceDetailsMutation,
    useDeleteInvoiceDetailsMutation,
} = invoiceDetailsApi;
